import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData,
  type UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutError,
  type UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutResponse,
  updatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPut,
} from '../../generated';

export type UpdatePdpMutationVariables = UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData['path'] &
  UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutData['body'];

export type UpdatePdpMutation = UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutResponse;

export const useUpdatePdpMutation = <TError = UpdatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPutError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<UpdatePdpMutation, TError, UpdatePdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UpdatePdpMutation, TError, UpdatePdpMutationVariables, TContext>({
    mutationKey: ['UpdatePdp'],
    mutationFn: async ({ workspace_id, pdp_id, ...body }: UpdatePdpMutationVariables) => {
      const { data } = await updatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPut({
        path: { workspace_id, pdp_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUpdatePdpMutation.fetcher = (
  { workspace_id, pdp_id, ...body }: UpdatePdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await updatePdpV1WorkspacesWorkspaceIdPdpsPdpIdPut({
      path: { workspace_id, pdp_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
